import { render, staticRenderFns } from "./leoCalendarS.vue?vue&type=template&id=07ca2a61&scoped=true&"
import script from "./leoCalendarS.vue?vue&type=script&lang=js&"
export * from "./leoCalendarS.vue?vue&type=script&lang=js&"
import style0 from "./leoCalendarS.vue?vue&type=style&index=0&id=07ca2a61&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ca2a61",
  null
  
)

export default component.exports